import React, { useState, useEffect } from 'react';
import './CancellationModal.css';

const CancellationModal = ({ isOpen, onClose, onConfirm, reservation }) => {
  const [motif, setMotif] = useState('');
  const [loading, setLoading] = useState(false);
  const [timeInfo, setTimeInfo] = useState(null);

  // Calculer le temps restant avant le cours
  useEffect(() => {
    if (!reservation) return;

    const now = new Date();
    const courseDateTime = new Date(`${reservation.date}T${reservation.heure_debut}`);
    const heuresRestantes = (courseDateTime - now) / (1000 * 60 * 60);
    const joursRestants = Math.floor(heuresRestantes / 24);
    const heuresSeules = Math.floor(heuresRestantes % 24);

    const willBeRefunded = heuresRestantes >= 24;
    const canUseBonus = heuresRestantes < 24 && heuresRestantes >= 0;

    setTimeInfo({
      heuresRestantes: Math.max(0, heuresRestantes),
      joursRestants,
      heuresSeules,
      willBeRefunded,
      canUseBonus
    });
  }, [reservation]);

  const handleSubmit = async () => {
    setLoading(true);
    await onConfirm(motif);
    setLoading(false);
  };

  if (!isOpen || !reservation) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2>❌ Annuler le cours</h2>
          <button onClick={onClose} className="close-button">✕</button>
        </div>

        {/* Infos cours */}
        <div className="course-info">
          <h3>📅 Détails du cours</h3>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Date :</span>
              <span className="info-value">
                {new Date(reservation.date).toLocaleDateString('fr-FR', {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long'
                })}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Heure :</span>
              <span className="info-value">
                {reservation.heure_debut} - {reservation.heure_fin}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Professeur :</span>
              <span className="info-value">
                {reservation.profs?.nom || reservation.prof?.nom || 'Professeur'}
              </span>
            </div>
          </div>
        </div>

        {/* Temps restant */}
        {timeInfo && (
          <div className={`time-warning ${timeInfo.willBeRefunded ? 'success' : 'warning'}`}>
            <div className="time-icon">
              {timeInfo.willBeRefunded ? '✅' : '⚠️'}
            </div>
            <div className="time-content">
              <div className="time-title">
                Temps restant avant le cours
              </div>
              <div className="time-value">
                {timeInfo.joursRestants > 0 && `${timeInfo.joursRestants}j `}
                {timeInfo.heuresSeules}h
              </div>
            </div>
          </div>
        )}

        {/* Règles de remboursement */}
        <div className="refund-rules">
          <h3>💰 Règles de remboursement</h3>
          <div className={`rule ${timeInfo?.willBeRefunded ? 'active' : ''}`}>
            <span className="rule-icon">✅</span>
            <span className="rule-text">
              Annulation <strong>&gt; 24h</strong> avant le cours : <strong>Crédit remboursé</strong>
            </span>
          </div>
          <div className={`rule ${timeInfo?.canUseBonus ? 'active' : ''}`}>
            <span className="rule-icon">🎁</span>
            <span className="rule-text">
              <strong>BONUS</strong> : 1ère annulation &lt; 24h du mois : <strong>Crédit remboursé</strong>
            </span>
          </div>
          <div className="rule">
            <span className="rule-icon">❌</span>
            <span className="rule-text">
              Autres annulations &lt; 24h : <strong>Crédit non remboursé</strong>
            </span>
          </div>
        </div>

        {/* Champ motif */}
        <div className="motif-section">
          <label htmlFor="motif">Motif d'annulation (optionnel) :</label>
          <textarea
            id="motif"
            value={motif}
            onChange={(e) => setMotif(e.target.value)}
            placeholder="Ex: Empêchement personnel, maladie, changement de planning..."
            rows={3}
            maxLength={500}
          />
          <div className="char-count">{motif.length}/500</div>
        </div>

        {/* Actions */}
        <div className="modal-actions">
          <button onClick={onClose} className="btn-cancel" disabled={loading}>
            Retour
          </button>
          <button onClick={handleSubmit} className="btn-confirm" disabled={loading}>
            {loading ? '⏳ Annulation...' : 'Confirmer l\'annulation'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancellationModal;
